import type { account as en } from '../en/account';

export const account: Record<keyof typeof en, string> = {
  'account.nav.label': 'फ़ैमिली ऐप्स',
  'account.nav.chats': 'चैट',
  'account.nav.documents': 'डॉक्यूमेंट',
  'account.nav.links': 'लिंक',
  'account.nav.lists': 'लिस्ट',
  'account.header.closeSearch': 'सर्च बंद करें',
  'account.header.searchChats': 'चैट में खोजें',
  'account.header.calls': 'कॉल',
  'account.header.starred': 'स्टार किए संदेश',
  'account.header.yourAccount': 'आपका अकाउंट',
  'account.menu.families': 'मेरी फ़ैमिली',
  'account.menu.invitations': 'न्योते',
  'account.menu.mentions': 'मेंशन',
  'account.menu.profile': 'प्रोफ़ाइल',
  'account.menu.settings': 'सेटिंग्स',
  // Shape Twinden (M55, D198)
  'account.menu.ideas': 'Twinden को सँवारें',
  'account.menu.darkMode': 'डार्क मोड',
  'account.menu.lightMode': 'लाइट मोड',
  'account.menu.logOut': 'लॉग आउट',
  'account.passkeyHere.done': 'अब यह डिवाइस ख़ुद साइन इन कर सकता है',
  'account.passkeyHere.failed': 'पासकी नहीं बन पाई',
  'account.passkeyHere.title': 'इस डिवाइस पर जल्दी साइन इन करें?',
  'account.passkeyHere.body':
    'आपने दूसरे डिवाइस की पासकी से साइन इन किया है। यहाँ भी एक बना लें, तो अगली बार यह डिवाइस ख़ुद साइन इन कर लेगा। दूसरे डिवाइस की पासकी वैसी ही रहेगी।',
  'account.passkeyHere.create': 'पासकी बनाएँ',
  'account.passkeyHere.notNow': 'अभी नहीं',
  'account.avatar.wrongType': 'कृपया JPEG, PNG, GIF या WebP फ़ोटो चुनें',
  'account.avatar.tooBig': 'फ़ोटो 25 MB से छोटी होनी चाहिए',
  'account.avatar.readFailed': 'फ़ाइल पढ़ी नहीं जा सकी',
  'account.avatar.upload': 'अपलोड',
  'account.avatar.remove': 'फ़ोटो हटाएँ',
  'account.switcher.label': 'फ़ैमिली बदलें, अभी: {name}',
  'account.switcher.membersOne': '1 सदस्य',
  'account.switcher.membersOther': '{count} सदस्य',
  'account.switcher.pendingInvites': 'बाकी न्योते',
  'account.noFamily.title': 'पहले एक फ़ैमिली चुनें',
  'account.noFamily.body': 'फ़ैमिली ऐप्स ऊपर चुनी गई फ़ैमिली के लिए चलते हैं।',
  'account.relation.title': 'आप {name} को क्या बुलाते हैं?',
  'account.relation.hint': 'उनके नाम की जगह दिखेगा, सिर्फ़ आपको।',
  'account.relation.placeholder': 'या कोई नाम लिखें',
  'account.relation.label': 'आप उन्हें क्या बुलाते हैं',
  'account.relation.useName': 'उनका नाम ही रखें',
  'account.settings.never': 'कभी नहीं',
  'account.settings.testSent': 'टेस्ट नोटिफ़िकेशन भेज दिया',
  'account.settings.title': 'सेटिंग्स',
  'account.settings.subtitle': 'नोटिफ़िकेशन, आवाज़ें और यह डिवाइस',
  'account.settings.account': 'अकाउंट',
  'account.settings.appearance': 'दिखावट',
  'account.settings.darkModeHint': 'रात में आँखों को आराम',
  'account.settings.festivalTouches': 'त्योहार की सजावट',
  'account.settings.festivalTouchesHint':
    'त्योहारों पर होम स्क्रीन पर छोटा-सा दीया, पतंग या चाँद। सिर्फ़ इस डिवाइस पर।',
  'account.settings.notifications': 'नोटिफ़िकेशन',
  'account.settings.notificationsDescription':
    'संदेश, कॉल और फ़ैमिली की ख़बरें, Twinden बंद होने पर भी।',
  'account.settings.pushNotConfigured':
    'इस सर्वर पर अभी नोटिफ़िकेशन सेट नहीं हैं (VAPID keys चाहिए)।',
  // D307
  'account.settings.pushUnsupported': 'यहाँ नोटिफ़िकेशन चालू नहीं हो सकते',
  'account.settings.pushOn': 'नोटिफ़िकेशन चालू हैं',
  'account.settings.pushOff': 'नोटिफ़िकेशन बंद हैं',
  // D185
  'account.settings.pushInstall': 'सूचनाएँ पाने के लिए Twinden इंस्टॉल करें',
  'account.settings.pushInstallHint':
    'iPhone और iPad पर सूचनाएँ सिर्फ़ होम स्क्रीन वाले ऐप में आती हैं।',
  'account.settings.pushInstallHow': 'कैसे',
  'account.settings.noDevices': 'अभी कोई डिवाइस नहीं',
  'account.settings.devicesOne': '1 डिवाइस',
  'account.settings.devicesOther': '{count} डिवाइस',
  'account.settings.turnOff': 'बंद करें',
  'account.settings.turnOn': 'चालू करें',
  'account.settings.messages': 'संदेश',
  'account.settings.messagesLabel': 'संदेशों के नोटिफ़िकेशन',
  'account.settings.callsHint': 'आने वाली और छूटी कॉल',
  'account.settings.callsLabel': 'कॉल के नोटिफ़िकेशन',
  'account.header.gatherings': 'बुलावा',
  'account.settings.gatheringsHint': 'याद दिलाना और “अभी आओ” की घंटी',
  'account.settings.gatheringsLabel': 'बुलावे के नोटिफ़िकेशन',
  'account.settings.familyUpdates': 'फ़ैमिली की ख़बरें',
  'account.settings.familyUpdatesHint':
    'डॉक्यूमेंट, लिंक, लिस्ट, आपको सौंपे गए काम',
  'account.settings.familyUpdatesLabel': 'फ़ैमिली की ख़बरों के नोटिफ़िकेशन',
  'account.settings.muteFamily': '{name} को म्यूट करें',
  'account.settings.muteFamilyHint': 'इस फ़ैमिली से कोई नोटिफ़िकेशन नहीं',
  'account.settings.pushDevices': 'नोटिफ़िकेशन वाले डिवाइस',
  'account.settings.unknownDevice': 'अनजान डिवाइस',
  'account.settings.since': '{date} से',
  'account.settings.sendTest': 'टेस्ट नोटिफ़िकेशन भेजें',
  'account.settings.indianDates': 'भारतीय तारीख़ और समय',
  'account.settings.indianDatesOn': 'जैसे {sample}',
  'account.settings.indianDatesOff':
    'बंद: आपके डिवाइस का अपना तरीका, जैसे {sample}',
  'account.settings.photos': 'फ़ोटो',
  'account.settings.blessings': 'आशीर्वाद',
  'account.settings.blessingsDescription':
    'किसी के भी संदेश पर एक टैप में आशीर्वाद दें। यह जवाब की तरह जाता है, हर संदेश की तरह सुरक्षित।',
  'account.settings.blessingButton': 'संदेशों पर आशीर्वाद बटन',
  'account.settings.blessingButtonHint':
    'दूसरों के संदेशों के पास 🙏। वरना, हर संदेश के मेनू में आशीर्वाद है।',
  'account.settings.blessingWords': 'आपका आशीर्वाद',
  'account.settings.blessingWordsHint':
    'इसी डिवाइस पर रहता है। खाली छोड़ें तो “जीते रहो 🙏” जाएगा।',
  'account.settings.photosDescription':
    'आपकी भेजी फ़ोटो इस डिवाइस से कैसे जाएँ।',
  'account.settings.originalQuality': 'फ़ोटो असली क्वालिटी में भेजें',
  'account.settings.originalOn':
    'पूरे साइज़ में: भेजने और डाउनलोड होने में ज़्यादा समय।',
  'account.settings.originalOff':
    'बंद: फ़ोटो 1600 पिक्सल तक जाती हैं, जल्दी और हल्की। पूरा साइज़ रखना हो तो फ़ाइल की तरह भेजें।',
  'account.settings.sounds': 'आवाज़ और वाइब्रेशन',
  'account.settings.soundsDescription':
    'जब इस डिवाइस पर Twinden खुला हो। म्यूट की गई चैट और फ़ैमिली चुप रहती हैं।',
  'account.settings.messageSound': 'नए संदेश की आवाज़',
  'account.settings.ringtone': 'कॉल की रिंगटोन',
  'account.settings.vibrate': 'वाइब्रेट',
  'account.settings.cantVibrate':
    'यह ब्राउज़र वाइब्रेट नहीं कर सकता (iPhone और कंप्यूटर)',
  'account.settings.testSound': 'संदेश की आवाज़ सुनें',
  'account.settings.testRingtone': 'रिंगटोन सुनें',
  'account.settings.closedSounds':
    'Twinden बंद होने पर नोटिफ़िकेशन फ़ोन की अपनी आवाज़ और वाइब्रेशन से आते हैं; उन्हें फ़ोन की सेटिंग्स में बदलें।',
  'account.settings.install': 'Twinden इंस्टॉल करें',
  'account.settings.installDescription':
    'Twinden को अपनी होम स्क्रीन पर रखें। iPhone पर नोटिफ़िकेशन इंस्टॉल करने के बाद ही आते हैं।',
  'account.settings.installGuide': 'इस डिवाइस के लिए पूरा तरीका',
  'account.settings.installIphone':
    'iPhone या iPad: Share दबाएँ, फिर “Add to Home Screen”।',
  'account.settings.installAppleTab':
    'होम स्क्रीन वाला ऐप एक अलग डिवाइस गिना जाता है। इसे तब खोलें जब यह टैब अभी खुला हो, ताकि यह टैब उसे आपके संदेशों की चाबियाँ दे सके।',
  'account.settings.installDesktop':
    'कंप्यूटर पर Chrome या Edge: एड्रेस बार में इंस्टॉल वाला आइकन दबाएँ।',
  'account.role.root': 'रूट',
  'account.role.admin': 'एडमिन',
  'account.role.member': 'सदस्य',
  'account.profile.birthdaySaveFailed': 'आपका जन्मदिन सेव नहीं हो पाया',
  'account.profile.updated': 'प्रोफ़ाइल अपडेट हो गई',
  'account.profile.updateFailed': 'प्रोफ़ाइल अपडेट नहीं हो पाई',
  'account.profile.unknownError': 'अनजानी गड़बड़',
  'account.profile.renameFailed': 'डिवाइस का नाम नहीं बदल पाया',
  'account.profile.deviceRemoved': 'डिवाइस हटा दिया',
  'account.profile.removeFailed': 'डिवाइस नहीं हट पाया',
  'account.profile.linkFailed': 'लिंक नहीं बन पाया',
  'account.profile.linkCopied': 'लिंक कॉपी हो गया',
  'account.profile.copyFailed': 'लिंक कॉपी नहीं हो पाया',
  'account.profile.anotherPasskeyTitle': 'इस डिवाइस पर पासकी पहले से है',
  'account.profile.anotherPasskeyBody':
    'इसे कहीं और रखने के लिए एक और बनाएँ, जैसे NordPass जैसे पासवर्ड मैनेजर में: फ़ोन जब पूछे कि कहाँ सेव करें, तो उसे चुनें। फिर पुरानी वाली नीचे से हटा सकते हैं।',
  'account.profile.anotherPasskeyCreate': 'एक और पासकी बनाएँ',
  'account.profile.pictureUpdated': 'फ़ोटो बदल गई',
  'account.profile.pictureRemoved': 'फ़ोटो हटा दी',
  'account.profile.passkeyCreated': 'इस डिवाइस पर पासकी बन गई',
  'account.profile.yourName': 'आपका नाम',
  'account.profile.saveName': 'नाम सेव करें',
  'account.profile.changeName': 'नाम बदलें',
  'account.profile.birthday': 'जन्मदिन',
  'account.profile.birthdayDescription':
    'सिर्फ़ दिन और महीना, साल नहीं। आपकी फ़ैमिली इसे देखती है ताकि आपको बधाई दे सके।',
  'account.profile.month': 'महीना',
  'account.profile.day': 'दिन',
  'account.profile.noSuchDay': '{month} में {day} तारीख़ नहीं होती।',
  'account.profile.notAdded': 'नहीं जोड़ा',
  'account.profile.removeBirthday': 'अपना जन्मदिन हटाएँ',
  'account.profile.changeBirthday': 'अपना जन्मदिन बदलें',
  'account.profile.addBirthday': 'अपना जन्मदिन जोड़ें',
  'account.profile.change': 'बदलें',
  'account.profile.add': 'जोड़ें',
  'account.profile.families': 'मेरी फ़ैमिली',
  'account.profile.familiesDescription':
    'आप कई फ़ैमिली में हो सकते हैं और ऊपर से उनके बीच बदल सकते हैं।',
  'account.profile.noFamilies': 'आप अभी किसी फ़ैमिली में नहीं हैं।',
  'account.profile.manage': 'संभालें',
  'account.profile.devices': 'मेरे डिवाइस',
  'account.profile.devicesDescription':
    'हर फ़ोन या कंप्यूटर अपनी पासकी से साइन इन करता है। नया यहाँ जोड़ें; जो अब काम में नहीं, उसे हटा दें (आख़िरी वाला नहीं हटता)।',
  'account.profile.noDevices': 'कोई डिवाइस नहीं मिला।',
  'account.profile.unnamedDevice': 'बिना नाम का डिवाइस',
  'account.profile.added': '{added} को जोड़ा',
  'account.profile.addedUsed': '{added} को जोड़ा · आख़िरी बार {used}',
  'account.profile.device': 'डिवाइस',
  'account.profile.renameNamed': '{name} का नाम बदलें',
  'account.profile.removeNamed': '{name} हटाएँ',
  'account.profile.confirmItsYou': 'पुष्टि करें कि आप ही हैं…',
  'account.profile.addDevice': 'डिवाइस जोड़ें',
  'account.profile.waitingDevice': 'आपके डिवाइस का इंतज़ार…',
  'account.profile.passkeyHere': 'इस डिवाइस पर पासकी जोड़ें',
  'account.profile.keysSentOne': 'नए डिवाइस को 1 चैट की चाबी भेज दी',
  'account.profile.keysSentOther':
    'नए डिवाइस को {count} चैट की चाबियाँ भेज दीं',
  'account.profile.deviceReady': 'आपका नया डिवाइस तैयार है',
  'account.profile.deviceReadyHint':
    'अब वहाँ आपके संदेश खुलेंगे। आप इसे बंद कर सकते हैं।',
  'account.profile.qrAlt': 'आपके अकाउंट में डिवाइस जोड़ने वाला QR कोड',
  'account.profile.linkHint':
    'नए डिवाइस पर इसे कैमरे से स्कैन करें या वहाँ लिंक खोलें। यह एक ही बार चलेगा, अगले',
  'account.profile.linkHintEnd': ' तक।',
  'account.profile.copyLink': 'लिंक कॉपी करें',
  'account.profile.waitingNewDevice':
    'नए डिवाइस का इंतज़ार है। इसे खुला रखें: यही नए डिवाइस को आपके संदेशों की चाबियाँ देगा।',
  'account.profile.linkExpired':
    'इस लिंक का समय ख़त्म हो गया। डिवाइस तैयार हो तो नया बनाएँ।',
  'account.profile.newLink': 'नया लिंक बनाएँ',
  'account.profile.cancelLink': 'लिंक रद्द करें',
  'account.profile.renameDevice': 'डिवाइस का नाम बदलें',
  'account.profile.deviceName': 'डिवाइस का नाम',
  'account.profile.removeTitle': '“{name}” हटाएँ?',
  'account.profile.thisDevice': 'यह डिवाइस',
  'account.profile.removeBody':
    'इसकी पासकी काम करना बंद कर देगी, फिर यह साइन इन नहीं कर पाएगा। नए लिंक से इसे फिर जोड़ सकते हैं।',
  'account.profile.removeDevice': 'डिवाइस हटाएँ',
  'account.profile.keepIt': 'रहने दें',
  'account.families.left': '{name} छोड़ दी',
  'account.families.leaveFailed': 'फ़ैमिली छोड़ी नहीं जा सकी',
  'account.families.subtitle':
    'हर फ़ैमिली की अपनी जगह है, अपने लोग, अपनी चैट और चीज़ें।',
  'account.families.invitedOne': 'आपको एक फ़ैमिली का न्योता मिला है',
  'account.families.invitedOther': 'आपको {count} फ़ैमिली के न्योते मिले हैं',
  'account.families.review': 'देखें',
  'account.families.emptyTitle': 'आप अभी किसी फ़ैमिली में नहीं हैं',
  'account.families.emptyBody':
    'Twinden पर फ़ैमिली चलाने वाला कोई भी आपको न्योता भेज सकता है। न्योते यहाँ दिखेंगे।',
  'account.families.checkInvites': 'न्योते देखें',
  'account.families.open': '{name} खोलें',
  'account.families.actions': 'फ़ैमिली के विकल्प',
  'account.families.openChats': 'चैट खोलें',
  'account.families.manage': 'फ़ैमिली संभालें',
  'account.families.leave': 'फ़ैमिली छोड़ें',
  'account.families.leaveTitle': '{name} छोड़ें?',
  'account.families.thisFamily': 'यह फ़ैमिली',
  'account.families.leaveBody':
    'फिर आपको इसकी चैट, डॉक्यूमेंट, लिंक और लिस्ट नहीं दिखेंगी। एडमिन नए QR कोड से आपको वापस बुला सकते हैं।',
  'account.families.stay': 'रुकें',
  'account.admin.justNow': 'अभी-अभी',
  'account.admin.minutesAgo': '{count} मिनट पहले',
  'account.admin.hoursAgo': '{count} घंटे पहले',
  'account.admin.daysAgo': '{count} दिन पहले',
  'account.admin.iconUpdated': 'फ़ैमिली की फ़ोटो बदल गई',
  'account.admin.iconRemoved': 'फ़ैमिली की फ़ोटो हटा दी',
  'account.admin.iconFailed': 'फ़ैमिली की फ़ोटो नहीं बदल पाई',
  'account.admin.createInviteFailed': 'न्योता नहीं बन पाया',
  'account.admin.roleChanged': 'रोल बदलकर {role} कर दिया',
  'account.admin.roleFailed': 'रोल नहीं बदल पाया',
  'account.admin.removeConfirm': '{name} को {family} से हटाएँ?',
  'account.admin.removed': '{name} को हटा दिया',
  'account.admin.removeFailed': 'सदस्य को हटा नहीं पाए',
  'account.admin.copyFailed': 'कॉपी नहीं हुआ — लिंक ख़ुद सिलेक्ट करें',
  'account.admin.notFound': 'फ़ैमिली नहीं मिली',
  'account.admin.backToFamilies': 'फ़ैमिली पर वापस',
  'account.admin.tokenEnroll': '@{handle} ({name}), {role} के रूप में',
  'account.admin.tokenEnrollName': '{name}, {role} के रूप में',
  'account.knows.title': 'किसी जान-पहचान वाले को जोड़ें',
  'account.knows.hint':
    'आपकी दूसरी फ़ैमिलीज़ के लोग। उन्हें न्योता जाता है, और वे हाँ कहें तभी जुड़ते हैं।',
  'account.knows.search': 'नाम या @हैंडल से खोजें',
  'account.knows.empty': 'आपकी दूसरी फ़ैमिलीज़ में यहाँ बुलाने लायक कोई नहीं।',
  'account.knows.noMatch': '“{query}” से कोई नहीं मिला।',
  'account.knows.pick': '{name} को बुलाएँ',
  'account.knows.inviting': '{name} को बुला रहे हैं',
  'account.knows.role': 'रोल',
  'account.knows.send': 'न्योता भेजें',
  'account.knows.cancel': 'किसी और को चुनें',
  'account.knows.sent': '{name} को न्योता भेज दिया',
  'account.knows.sentHint': 'वे जुड़ें दबाएँगे, तब जुड़ेंगे।',
  'account.knows.failed': 'न्योता नहीं भेज पाए',
  'account.knows.loadFailed': 'जान-पहचान वाले लोग नहीं दिखा पाए',
  'account.invites.invitedYou':
    '{name} ने आपको {family} से जुड़ने का न्योता भेजा है',
  // Family handles (M59, D215–D217)
  'account.familyHandle.edit': 'नाम और हैंडल बदलें',
  'account.familyHandle.title': 'नाम और हैंडल',
  'account.familyHandle.label': 'फ़ैमिली हैंडल',
  'account.familyHandle.hint':
    'इसी नाम की दूसरी फ़ैमिलियों से आपकी फ़ैमिली को अलग पहचान देता है।',
  'account.familyHandle.changesLeft':
    '30 दिनों में 3 बार बदल सकते हैं ({count} बाकी)।',
  'account.familyHandle.noneLeft':
    '30 दिनों में 3 बार बदल चुके हैं। बाद में फिर बदल सकेंगे।',
  'account.familyHandle.rootsOnly': 'हैंडल सिर्फ़ रूट बदल सकते हैं।',
  'account.familyHandle.checking': 'देख रहे हैं…',
  'account.familyHandle.free': '@{handle} खाली है',
  'account.familyHandle.taken': '@{handle} पहले से लिया हुआ है',
  'account.familyHandle.reserved': '@{handle} आरक्षित है',
  'account.familyHandle.invalid':
    '3–32 छोटे अक्षर, अंक या एक-एक डैश लिखें, शुरू या आख़िर में डैश नहीं',
  'account.familyHandle.links':
    'फ़ैमिली लिंक चलते रहेंगे। पुराना हैंडल आपके लिए नहीं रखा जाएगा।',
  'account.familyHandle.saved': 'सहेज लिया',
  'account.familyHandle.saveFailed': 'सहेज नहीं पाए',
  'account.familyHandle.limit': 'हैंडल {date} को फिर बदल सकेंगे।',
  'account.admin.renamed': 'फ़ैमिली का नाम बदल गया',
  'account.admin.renameFailed': 'फ़ैमिली का नाम नहीं बदल पाया',
  'account.admin.rename': 'फ़ैमिली का नाम बदलें',
  'account.admin.subtitleOne': 'यहाँ आप {role} हैं · {count} सदस्य',
  'account.admin.subtitleOther': 'यहाँ आप {role} हैं · {count} सदस्य',
  'account.admin.members': 'सदस्य',
  'account.admin.invite': 'न्योता',
  'account.admin.pending': 'बाकी',
  'account.admin.activity': 'गतिविधि',
  'account.admin.youBadge': 'आप',
  'account.admin.joined': '{time} जुड़े',
  'account.admin.memberActions': 'सदस्य के विकल्प',
  'account.admin.makeRoot': 'रूट बनाएँ',
  'account.admin.makeAdmin': 'एडमिन बनाएँ',
  'account.admin.makeMember': 'सदस्य बनाएँ',
  'account.admin.removeFromFamily': 'फ़ैमिली से हटाएँ',
  'account.admin.inviteNew': 'किसी नए को बुलाएँ',
  'account.admin.inviteNewHint':
    'एक बार चलने वाला QR कोड / लिंक बनता है। नए लोग अपने डिवाइस पर हैंडल चुनकर पासकी बनाते हैं; जो पहले से Twinden पर हैं, वे अपने ही अकाउंट से जुड़ते हैं।',
  'account.admin.handle': 'हैंडल',
  'account.admin.displayName': 'दिखने वाला नाम',
  'account.admin.role': 'रोल',
  'account.admin.createInvite': 'न्योता बनाएँ',
  'account.admin.pendingLinks': 'बाकी जुड़ने वाले लिंक',
  'account.admin.noPendingLinks': 'कोई लिंक बाकी नहीं।',
  'account.admin.createdExpires': '{ago} बना · {date} तक चलेगा',
  'account.admin.regenerateFailed': 'नया नहीं बन पाया',
  'account.admin.newLink': 'नया लिंक',
  'account.admin.revokeFailed': 'रद्द नहीं हो पाया',
  'account.admin.revoke': 'रद्द करें',
  'account.admin.pendingInvites': 'ऐप में बाकी न्योते',
  'account.admin.noPendingInvites': 'कोई न्योता बाकी नहीं।',
  'account.admin.handleAs': '@{handle}, {role} के रूप में',
  'account.admin.invitedExpires': '{ago} बुलाया · {date} तक चलेगा',
  'account.admin.waiting': 'इंतज़ार',
  'account.admin.noActivity': 'अभी तक कोई गतिविधि नहीं।',
  'account.admin.systemRoot': 'सिस्टम रूट',
  'account.admin.familyName': 'फ़ैमिली का नाम',
  'account.admin.inviteLink': 'न्योते का लिंक',
  'account.admin.qrAlt': 'न्योते का QR कोड',
  'account.admin.qrEnroll':
    '{name} से कहें कि जिस डिवाइस पर Twinden चलाएँगे, उस पर इसे स्कैन करें। यह एक ही बार चलेगा, {date} तक।',
  'account.invites.joined': 'फ़ैमिली से जुड़ गए',
  'account.invites.joinedHint': 'अब आप इसके ग्रुप और चैट खोल सकते हैं।',
  'account.invites.acceptFailed': 'न्योता मान नहीं पाए',
  'account.invites.declined': 'न्योता मना कर दिया',
  'account.invites.declineFailed': 'मना नहीं कर पाए',
  'account.invites.subtitle':
    'जो फ़ैमिली आपको जोड़ना चाहती हैं। आपका अकाउंट और हैंडल वही रहेगा।',
  'account.invites.checkAgain': 'फिर देखें',
  'account.invites.emptyTitle': 'कोई न्योता नहीं',
  'account.invites.emptyBody':
    'जब कोई फ़ैमिली आपको बुलाएगी, तो न्योता यहाँ दिखेगा और आपकी फ़ोटो पर एक बिंदी आएगी।',
  'account.invites.details': '{role} के रूप में · @{handle} से · {date} तक',
  'account.invites.join': 'जुड़ें',
  'account.invites.noThanks': 'अभी नहीं',
  'account.login.unknownCredential': 'यह पासकी इस सर्वर पर दर्ज नहीं है।',
  'account.login.sessionExpired':
    'साइन इन का समय ख़त्म हो गया। फिर कोशिश करें।',
  'account.login.verificationFailed':
    'पासकी की जाँच नहीं हो पाई। फिर कोशिश करें।',
  'account.login.compromised':
    'सुरक्षा के लिए यह पासकी बंद कर दी गई है। किसी दूसरी पासकी से साइन इन करें, या जिस डिवाइस पर आप साइन इन हैं वहाँ से यह डिवाइस जोड़ें।',
  'account.login.cancelled':
    'पासकी वाली विंडो बंद हो गई। फिर कोशिश करने के लिए बटन दबाएँ।',
  'account.login.tryAgain': 'कुछ गड़बड़ हो गई। फिर कोशिश करें।',
  'account.login.subtitle':
    'आपकी फ़ैमिली की अपनी जगह, बात करने, शेयर करने और चीज़ें सँभालने के लिए।',
  'account.login.noAccount':
    'अभी अकाउंट नहीं है? फ़ैमिली में किसी से जुड़ने का QR कोड माँगें, या {request}।',
  'account.login.requestInvite': 'न्योते के लिए अर्ज़ी दें',
  'account.login.help': 'मदद',
  'account.login.whatIs': 'Twinden क्या है?',
  'account.login.installFirst': 'पहले Twinden इंस्टॉल करें',
  'account.login.installFirstBody':
    '{share} दबाएँ, फिर {add}, और नए आइकन से साइन इन करें। नोटिफ़िकेशन मिलेंगे, और आपके संदेशों के लिए यह फ़ोन दो नहीं, एक ही डिवाइस रहेगा।',
  'account.login.showMe': 'तरीका दिखाएँ',
  'account.login.continueSafari': 'Safari में ही चलाएँ',
  'account.login.getAppBody':
    'App Store से Twinden लें और वहीं साइन इन करें। नोटिफ़िकेशन मिलेंगे, और आपके संदेशों के लिए यह फ़ोन दो नहीं, एक ही डिवाइस रहेगा।',
  'account.login.signIn': 'पासकी से साइन इन करें',
  'account.login.unsupported':
    'यह ब्राउज़र पासकी नहीं चला सकता। नया Chrome, Safari, Firefox या Edge इस्तेमाल करें।',
  'account.login.noPassword':
    'आपका चेहरा, फ़िंगरप्रिंट या स्क्रीन लॉक ही साइन इन करता है। कोई पासवर्ड याद नहीं रखना।',
  'account.join.tokenNotFound':
    'यह जुड़ने वाला लिंक सही नहीं है। अपनी फ़ैमिली के रूट से नया माँगें।',
  'account.join.tokenConsumed':
    'यह लिंक पहले ही इस्तेमाल हो चुका है। अगर इससे आपका अकाउंट बना था, तो बस अपनी पासकी से साइन इन करें।',
  'account.join.addDeviceSelfOnly':
    'अपने अकाउंट में डिवाइस सिर्फ़ आप जोड़ सकते हैं: जिस डिवाइस पर आप साइन इन हैं, वहाँ प्रोफ़ाइल → मेरे डिवाइस → डिवाइस जोड़ें पर जाएँ।',
  'account.join.tokenRevoked':
    'यह जुड़ने वाला लिंक रद्द कर दिया गया है। अपनी फ़ैमिली के रूट से नया माँगें।',
  'account.join.tokenExpired':
    'इस जुड़ने वाले लिंक का समय ख़त्म हो गया। अपनी फ़ैमिली के रूट से नया माँगें।',
  'account.join.handleTaken':
    'यह हैंडल अभी-अभी किसी और ने ले लिया। अपनी फ़ैमिली के रूट से जुड़ने का लिंक दोबारा बनवाएँ।',
  'account.join.alreadyRegistered':
    'इस डिवाइस पर पहले से पासकी है। सीधे साइन इन करें।',
  'account.join.sessionExpired': 'जुड़ने का समय ख़त्म हो गया। फिर कोशिश करें।',
  'account.join.wrongOrigin':
    'यह लिंक उसी पते पर खोलना होगा जिसके लिए सर्वर सेट है (.env में RP_ID/ORIGIN देखें)।',
  'account.join.alreadyHasPasskey':
    'इस डिवाइस पर इस अकाउंट की पासकी पहले से है। सीधे साइन इन करें।',
  'account.join.errorDetail': 'कुछ गड़बड़ हो गई: {detail}',
  'account.join.invalid': 'यह जुड़ने वाला लिंक सही नहीं है।',
  'account.join.joining': 'जुड़ रहे हैं…',
  'account.join.unsupportedTitle': 'इस ब्राउज़र से नहीं जुड़ सकते',
  'account.join.unsupportedBody':
    'यह पासकी नहीं बना सकता। यह लिंक किसी नए फ़ोन या कंप्यूटर पर खोलें: iOS 16 या उसके बाद, Android 9 या उसके बाद, या नया Chrome, Safari, Firefox या Edge।',
  'account.join.errorTitle': 'इस लिंक से नहीं जुड़ सकते',
  'account.join.almostTitle': 'बस हो ही गया',
  'account.join.almostBody':
    'अपनी पासकी बनाने के लिए डिवाइस पर जो दिखे, वह करें।',
  'account.join.addDevice': 'यह डिवाइस जोड़ें',
  'account.join.welcome': 'स्वागत है, {name}',
  'account.join.addDeviceBody':
    'यह डिवाइस {family} में @{handle} के नाम से साइन इन करेगा।',
  'account.join.joiningBody':
    'आप {family} में @{handle} के नाम से जुड़ रहे हैं।',
  'account.join.joiningBodyPick':
    'आप {family} से जुड़ रहे हैं। अपना हैंडल चुनें।',
  'account.join.addDeviceFooter': 'इससे इस डिवाइस पर एक पासकी बनेगी।',
  'account.join.joiningFooter':
    'एक टैप में अकाउंट बन जाएगा। कोई पासवर्ड नहीं, कभी नहीं।',
  'account.join.nameDevice': 'इस डिवाइस का नाम (चाहें तो)',
  'account.join.nameDevicePlaceholder': 'जैसे, मेरा iPhone',
  'account.join.createPasskey': 'मेरी पासकी बनाएँ',
  'account.install.notifications':
    'नोटिफ़िकेशन चालू करें: ऊपर दाईं ओर अपनी फ़ोटो दबाएँ, फिर {path}, और {allow}।',
  'account.install.openSettings': 'सेटिंग्स खोलें',
  'account.install.subtitle':
    'Twinden को ऐप की तरह होम स्क्रीन पर रखें, फिर नोटिफ़िकेशन चालू करें।',
  'account.install.back': 'Twinden पर वापस',
  // The store app first, when its link is set (D346)
  'account.install.getApp': 'Twinden ऐप पाएँ',
  'account.install.getAppBody':
    'स्टोर से इंस्टॉल करें, खोलें और साइन इन करें। सूचनाएँ और कॉल वहाँ सबसे अच्छी चलती हैं।',
  'account.install.orWebApp': 'या वेब ऐप को होम स्क्रीन पर रखें',
  'account.install.installed': 'इस डिवाइस पर Twinden इंस्टॉल है।',
  'account.install.safariFirst':
    'पहले twinden.com को Safari में खोलें: iPhone पर नोटिफ़िकेशन सिर्फ़ Safari से जोड़े गए ऐप्स पर आते हैं।',
  'account.install.ios1':
    'Safari में {share} दबाएँ: तीर वाला चौकोर, स्क्रीन के नीचे (iPad पर ऊपर)।',
  'account.install.ios2': 'नीचे स्क्रॉल करके {add} दबाएँ, फिर {confirm}।',
  'account.install.fromIcon': 'नए आइकन से Twinden',
  'account.install.ios3': 'होम स्क्रीन पर {fromIcon} खोलें, Safari से नहीं।',
  'account.install.ios4': 'अपनी पासकी से साइन इन करें।',
  'account.install.ios4Keys':
    'ऐप इस Safari टैब से अलग डिवाइस है: जब तक ऐप में “आपके संदेश खुल गए” न दिखे, {keepOpen}, ताकि यह टैब उसे आपके संदेशों की चाबियाँ दे सके।',
  'account.install.keepOpen': 'यह टैब खुला रखें',
  'account.install.tapInstall': '{button} दबाएँ और हाँ करें।',
  'account.install.android1':
    'Chrome में ऊपर दाईं ओर मेन्यू {menu} दबाएँ, फिर {installApp} (या {addHome})।',
  'account.install.android2': '{fromIcon} खोलें। आप साइन इन ही रहेंगे।',
  'account.install.clickInstall': '{button} पर क्लिक करें और हाँ करें।',
  'account.install.installIcon': 'इंस्टॉल वाला आइकन',
  'account.install.computer1':
    'Chrome या Edge में एड्रेस बार के दाईं ओर {icon} पर क्लिक करें। Mac पर Safari में {dock}। (Firefox ऐप इंस्टॉल नहीं कर सकता, पर ब्राउज़र में नोटिफ़िकेशन फिर भी आते हैं।)',
  'account.devices.iphone': 'मेरा iPhone',
  'account.devices.ipad': 'मेरा iPad',
  'account.devices.android': 'मेरा Android फ़ोन',
  'account.devices.mac': 'मेरा Mac',
  'account.devices.windows': 'मेरा Windows PC',
  'account.devices.linux': 'मेरा Linux डिवाइस',
  'account.devices.alreadyHasPasskey':
    'इस डिवाइस पर आपके अकाउंट की पासकी पहले से है।',
  // D307, D308
  'account.push.why.appleTab':
    'iPhone और iPad पर नोटिफ़िकेशन सिर्फ़ होम स्क्रीन वाले ऐप में आते हैं। Safari में Share → “Add to Home Screen” दबाएँ, वहीं से Twinden खोलें, फिर इन्हें चालू करें।',
  'account.push.why.insecure':
    'नोटिफ़िकेशन के लिए सुरक्षित पता चाहिए। Twinden को उसके https:// पते पर खोलें।',
  'account.push.why.privateWindow':
    'प्राइवेट विंडो में नोटिफ़िकेशन नहीं चलते। इन्हें चालू करने के लिए Twinden को सामान्य विंडो में खोलें।',
  'account.push.why.noServiceWorker':
    'यह ब्राउज़र यहाँ Twinden को पीछे से नहीं चला सकता, इसलिए नोटिफ़िकेशन नहीं दिखा सकता। प्राइवेट विंडो हो तो सामान्य विंडो खोलें; किसी दूसरे ऐप (जैसे WhatsApp या Instagram) के अंदर हों तो लिंक अपने ब्राउज़र में खोलें; नहीं तो ब्राउज़र अपडेट करें।',
  'account.push.why.unsupported':
    'यह ब्राउज़र नोटिफ़िकेशन नहीं दिखा सकता। इसे अपडेट करें, या Chrome, Edge, Firefox या Safari इस्तेमाल करें।',
  'account.push.why.swFailed':
    'इस ब्राउज़र में Twinden का बैकग्राउंड हेल्पर शुरू नहीं हो पाया, इसलिए नोटिफ़िकेशन चालू नहीं हो सकते। पेज दोबारा लोड करें; बार-बार हो तो इस ब्राउज़र में Twinden का स्टोरेज ख़राब हो सकता है, और Chrome या Firefox जैसा दूसरा ब्राउज़र चलेगा।',
  'account.push.why.blocked':
    'इस साइट के नोटिफ़िकेशन बंद हैं। पते के पास ताले या सेटिंग्स वाले आइकन पर टैप करें, Notifications की इजाज़त दें, फिर पेज दोबारा लोड करें। प्राइवेट या इनकॉग्निटो विंडो में ये हमेशा बंद रहते हैं: सामान्य विंडो खोलें।',
  'account.push.why.brave':
    'Brave वेब नोटिफ़िकेशन तब तक बंद रखता है जब तक आप इजाज़त न दें: brave://settings/privacy खोलें, “Use Google services for push messaging” चालू करें, Brave दोबारा शुरू करें, फिर कोशिश करें।',
  'account.push.why.pushService':
    'ब्राउज़र की नोटिफ़िकेशन सेवा ने जवाब नहीं दिया। कनेक्शन देखें और दोबारा कोशिश करें। प्राइवेट विंडो हो तो सामान्य विंडो खोलें।',
  'account.push.why.subscribeFailed':
    'नोटिफ़िकेशन चालू नहीं हो पाए। ब्राउज़र ने कहा: {reason}',
  'account.push.notConfigured': 'इस सर्वर पर नोटिफ़िकेशन सेट नहीं हैं',
  'account.push.notGranted': 'नोटिफ़िकेशन की इजाज़त नहीं मिली',
  'account.push.incomplete': 'ब्राउज़र से अधूरी जानकारी मिली',
  'account.push.enableFailed': 'नोटिफ़िकेशन चालू नहीं हो पाए',
  'account.push.disableFailed': 'नोटिफ़िकेशन बंद नहीं हो पाए',
  'account.push.saveFailed': 'नोटिफ़िकेशन की पसंद सेव नहीं हो पाई',
  'account.push.testFailed': 'टेस्ट नोटिफ़िकेशन नहीं भेज पाए',
  'account.family.loadFamiliesFailed': 'फ़ैमिली लोड नहीं हो पाईं',
  'account.family.loadFailed': 'फ़ैमिली लोड नहीं हो पाई',
  'account.family.noneSelected': 'कोई फ़ैमिली नहीं चुनी',
  // Fun handles (D147)
  'account.handle.label': 'हैंडल',
  'account.handle.shuffle': 'दूसरा हैंडल',
  'account.handle.finding': 'मज़ेदार हैंडल ढूँढ रहे हैं…',
  'account.handle.failed': 'हैंडल नहीं मिला। फिर से पासा दबाएँ।',
  'account.handle.forever': 'हैंडल बाद में बदला नहीं जा सकता।',
  'account.handle.needName': 'पहले नाम लिखें, फिर हम हैंडल बना देंगे।',
  'account.handle.takenReplaced': '@{handle} अभी-अभी कोई ले गया। ये रहा दूसरा।',
  // Invite people with the family link (D152)
  'account.invite.title': '{family} में लोगों को बुलाएँ',
  'account.invite.menu': 'लोगों को बुलाएँ',
  'account.invite.body':
    'इस लिंक से कोई भी जुड़ने के लिए पूछ सकता है। रूट या एडमिन उन्हें अंदर लेते हैं।',
  'account.invite.share': 'लिंक भेजें',
  'account.invite.copy': 'लिंक कॉपी करें',
  'account.invite.copied': 'लिंक कॉपी हो गया',
  'account.invite.shareText': 'Twinden पर {family} से जुड़िए',
  'account.invite.qrAlt': 'फ़ैमिली लिंक का QR कोड',
  'account.invite.off': 'फ़ैमिली लिंक बंद है।',
  'account.invite.offMember': 'किसी रूट या एडमिन से इसे चालू करने को कहें।',
  'account.invite.reset': 'नया लिंक बनाएँ',
  'account.invite.turnOff': 'बंद करें',
  'account.invite.turnOn': 'लिंक चालू करें',
  'account.invite.resetTitle': 'फ़ैमिली लिंक बदलें?',
  'account.invite.resetBody':
    'पुराना लिंक और QR हर जगह तुरंत बंद हो जाएँगे। जिन्होंने पहले से पूछा है, वे लिस्ट में बने रहेंगे।',
  'account.invite.offTitle': 'फ़ैमिली लिंक बंद करें?',
  'account.invite.offBody':
    'दोबारा चालू होने तक कोई जुड़ने के लिए नहीं पूछ पाएगा। आप इसे कभी भी चालू कर सकते हैं।',
  'account.invite.resetDone': 'नया फ़ैमिली लिंक तैयार है',
  'account.invite.offDone': 'फ़ैमिली लिंक बंद हो गया',
  'account.invite.onDone': 'फ़ैमिली लिंक चालू हो गया',
  'account.invite.loadFailed': 'फ़ैमिली लिंक लोड नहीं हो पाया',
  'account.invite.cardBody':
    'पूरी फ़ैमिली के लिए एक लिंक। WhatsApp पर भेजें या QR दिखाएँ।',
  'account.invite.open': 'फ़ैमिली लिंक दिखाएँ',
  // People asking to join (D154)
  'account.requests.tab': 'अर्ज़ियाँ',
  // Family reports (M58, D207)
  'account.reports.tab': 'शिकायतें',
  'account.reports.title': 'शिकायतें',
  'account.reports.description':
    'वे सदस्य जिनकी आपके परिवार के किसी व्यक्ति ने शिकायत की। Twinden मैसेज नहीं पढ़ सकता, इसलिए शिकायत में बस यह होता है कि किसकी, क्यों और कोई नोट, यह नहीं कि क्या कहा गया।',
  'account.reports.none': 'कोई शिकायत नहीं।',
  'account.reports.line': '{reporter} ने {reported} की शिकायत की',
  'account.reports.someone': 'कोई',
  'account.reports.aboutMessage': 'एक मैसेज के बारे में',
  'account.reports.handled': 'निपटा दी गई',
  'account.reports.markHandled': 'निपटा दी गई मानें',
  'account.reports.markUnhandled': 'फिर से खोलें',
  'account.reports.failed': 'सहेजा नहीं जा सका',
  // Settings: blocked people and about (M58, D208, D209)
  'account.blocked.title': 'ब्लॉक किए गए लोग',
  'account.blocked.description':
    'जिन्हें आपने ब्लॉक किया है वे आपको सीधे मैसेज या कॉल नहीं कर सकते। परिवार के ग्रुप पर इसका असर नहीं होता।',
  'account.blocked.none': 'आपने किसी को ब्लॉक नहीं किया है।',
  'account.blocked.unblock': 'अनब्लॉक करें',
  'account.blocked.unblocked': '{name} अनब्लॉक हो गए',
  'account.blocked.failed': 'अनब्लॉक नहीं किया जा सका',
  'account.blocked.deleted': 'हटाया गया खाता',
  'account.about.title': 'जानकारी',
  'account.about.contact': 'Twinden से संपर्क करें',
  'account.about.contactHint': 'सवाल, परेशानी या कुछ बताना हो तो हमें लिखें।',
  'account.about.help': 'मदद',
  'account.about.privacy': 'गोपनीयता नीति',
  'account.about.terms': 'उपयोग की शर्तें',
  'account.about.contactPage': 'संपर्क',
  'account.requests.title': 'जुड़ना चाहने वाले लोग',
  'account.requests.empty': 'अभी कोई जुड़ने के लिए नहीं पूछ रहा।',
  'account.requests.via': '{name} के ज़रिए',
  'account.requests.approve': 'मंज़ूर करें',
  'account.requests.decline': 'मना करें',
  'account.requests.approveAll': 'सबको मंज़ूर करें ({count})',
  'account.requests.roleFor': '{name} की भूमिका',
  'account.requests.approved': '{name} जुड़ गए',
  'account.requests.declined': 'मना कर दिया',
  'account.requests.approvedAll': '{count} लोग जुड़ गए',
  'account.requests.declineTitle': '{name} को मना करें?',
  'account.requests.declineBody':
    'उन्हें वजह नहीं बताई जाएगी, और वे एक हफ़्ते बाद फिर पूछ सकते हैं।',
  'account.requests.failed': 'ये नहीं हो पाया',
  'account.requests.loadFailed': 'अर्ज़ियाँ लोड नहीं हो पाईं',
  'account.requests.asking': '{count} जुड़ना चाहते हैं',
  'account.join.linkTitle': '{family} से जुड़ें',
  'account.join.sharedBy': '{name} ने आपको यह लिंक भेजा है।',
  'account.join.imNew': 'Twinden मेरे लिए नया है',
  'account.join.alreadyUse': 'मेरा Twinden पर पहले से खाता है',
  'account.join.chooseFooter':
    'पहले से Twinden पर हैं? साइन इन करें, ताकि दूसरा खाता न बने।',
  // Join links open in the app once it's installed (D346)
  'account.join.getApp': 'ऐप चाहिए?',
  'account.join.getAppBody':
    'Twinden इंस्टॉल करें, फिर यह लिंक दोबारा खोलें: यह ऐप में खुलेगा।',
  'account.join.continueAs': '{name} के रूप में आगे बढ़ें',
  'account.join.notYou': 'आप नहीं हैं?',
  'account.join.signOut': 'साइन आउट करें',
  'account.join.yourName': 'आपका नाम',
  'account.join.yourNamePlaceholder': 'जैसे रवि शर्मा',
  'account.join.youllBe': 'आपका हैंडल होगा',
  'account.join.note': 'परिवार के लिए एक संदेश (ज़रूरी नहीं)',
  'account.join.notePlaceholder': 'जैसे सुनील की बेटी',
  'account.join.askToJoin': 'जुड़ने के लिए पूछें',
  'account.join.newFooter':
    'परिवार आपका नाम, हैंडल और संदेश देखेगा, फिर आपको जोड़ेगा।',
  'account.join.deadLink':
    'यह लिंक अब काम नहीं करता — परिवार से नया लिंक माँगें',
  'account.join.notAddedThisTime': '{family} ने इस बार आपको नहीं जोड़ा।',
  'account.join.tooMany':
    '{family} से जुड़ने के लिए अभी बहुत लोग इंतज़ार में हैं। थोड़ी देर बाद फिर कोशिश करें।',
  'account.join.waitingTitle': 'आपको जोड़ने के लिए {family} से पूछा जा रहा है',
  'account.join.waitingBody':
    'परिवार में कोई आपको जोड़ेगा। जैसे ही जोड़ेंगे, परिवार यहाँ दिखेगा।',
  'account.join.openTwinden': 'Twinden खोलें',
  'account.join.personalTitle': '{family} से जुड़ें?',
  'account.join.personalBody': 'आप अपने खाते @{handle} से जुड़ेंगे।',
  'account.join.join': 'जुड़ें',
  'account.join.alreadyIn': 'आप पहले से {family} में हैं',
  'account.waiting.cancel': 'अनुरोध रद्द करें',
  'account.waiting.cancelled': 'अनुरोध रद्द हो गया',
  'account.waiting.noneTitle': 'आप अभी किसी परिवार में नहीं हैं',
  'account.waiting.noneBody':
    'अपने परिवार में किसी से उनका परिवार लिंक या आपके लिए बना लिंक माँगें, और उसे इसी डिवाइस पर खोलें।',
  'account.waiting.youreIn': 'आप {family} में आ गए',
  'account.waiting.loadFailed': 'आपके अनुरोध लोड नहीं हो पाए',
  'account.scan.heading': 'अपने फ़ोन पर Twinden से स्कैन करें',
  'account.scan.choose': 'अपने फ़ोन पर {number} चुनें',
  'account.scan.steps': 'प्रोफ़ाइल → मेरे डिवाइस → स्कैन करके साइन इन',
  'account.scan.qrAlt': 'फ़ोन से साइन इन करने का QR कोड',
  'account.scan.newCode': 'नया कोड दिखाएँ',
  'account.scan.stopped': 'यह कोड ख़त्म हो गया।',
  'account.scan.failed': 'कोड नहीं बन पाया। अपना कनेक्शन जाँचें।',
  'account.scan.limited':
    'इस नेटवर्क से बहुत सारे कोड बन गए। कुछ मिनट बाद फिर कोशिश करें।',
  'account.scan.onComputer': 'कंप्यूटर पर साइन इन कर रहे हैं?',
  'account.scan.hide': 'कोड छिपाएँ',
  'account.scanApprove.title': 'इस कंप्यूटर पर साइन इन करें?',
  'account.scanApprove.heading': 'कंप्यूटर पर साइन इन',
  'account.scanApprove.signInFirst':
    'पहले इस फ़ोन पर साइन इन करें, फिर कंप्यूटर पर साइन इन कर पाएँगे।',
  'account.scanApprove.signIn': 'अपनी पासकी से साइन इन करें',
  'account.scanApprove.says': 'कंप्यूटर के हिसाब से यह है',
  'account.scanApprove.saysNothing': 'कंप्यूटर ने नहीं बताया कि वह कौन-सा है।',
  'account.scanApprove.kind.iphone': 'एक iPhone',
  'account.scanApprove.kind.ipad': 'एक iPad',
  'account.scanApprove.kind.android': 'एक Android डिवाइस',
  'account.scanApprove.kind.mac': 'एक Mac',
  'account.scanApprove.kind.windows': 'एक Windows कंप्यूटर',
  'account.scanApprove.kind.linux': 'एक Linux कंप्यूटर',
  'account.scanApprove.madeAt': 'कोड {time} पर दिखाया गया',
  'account.scanApprove.warning':
    'सिर्फ़ वही कोड स्कैन करें जो आपके सामने की स्क्रीन पर दिख रहा हो। जिसे भी आप यह भेजेंगे, वह आपके संदेश पढ़ सकेगा।',
  'account.scanApprove.whichNumber': 'कंप्यूटर पर कौन-सा नंबर है?',
  'account.scanApprove.numberHint':
    'उसे दबाएँ, फिर अपनी पासकी से पुष्टि करें कि यह आप ही हैं।',
  'account.scanApprove.cancel': 'रद्द करें',
  'account.scanApprove.wrongNumber':
    'यह वह नंबर नहीं था — कंप्यूटर नया कोड दिखाएगा।',
  'account.scanApprove.expired':
    'इस कोड का समय ख़त्म हो गया। कंप्यूटर पर दिख रहा नया कोड स्कैन करें।',
  'account.scanApprove.cancelled': 'रद्द हो गया। कंप्यूटर नया कोड दिखाएगा।',
  'account.scanApprove.loadFailed':
    'यह कोड नहीं खुल पाया। अपना कनेक्शन जाँचें।',
  'account.scanApprove.sending': 'आपके संदेश कंप्यूटर पर भेजे जा रहे हैं…',
  'account.scanApprove.sendingHint':
    'कंप्यूटर तैयार होने तक यह स्क्रीन खुली रखें।',
  'account.scanApprove.done': 'हो गया',
  'account.scanApprove.doneHint':
    'कंप्यूटर पर साइन इन हो गया और आपके संदेश वहाँ पहुँच गए।',
  'account.scanApprove.doneNoKeys':
    'कंप्यूटर पर साइन इन हो गया। आपके संदेश उसे उस डिवाइस से मिलेंगे जिस पर वे हैं — अपने फ़ोन की होम स्क्रीन वाली Twinden ऐप खोलें।',
  'account.scanApprove.doneSoon':
    'आपके संदेश कुछ ही पलों में कंप्यूटर पर पहुँच जाएँगे।',
  'account.scanApprove.openOnPhone': 'इसे अपने फ़ोन पर खोलें',
  'account.scanApprove.openOnPhoneBody':
    'कंप्यूटर पर दिख रहा कोड उस फ़ोन से स्कैन करें जिस पर आप Twinden चलाते हैं।',
  'account.scanApprove.openTwinden': 'Twinden खोलें',
  'account.scanner.title': 'स्कैन करके साइन इन',
  'account.scanner.hint': 'कैमरा कंप्यूटर पर दिख रहे कोड की ओर करें।',
  'account.scanner.notCode': 'यह Twinden का साइन-इन कोड नहीं है',
  'account.scanner.denied':
    'Twinden कैमरा इस्तेमाल नहीं कर पा रहा। ब्राउज़र की सेटिंग में इस साइट के लिए कैमरा चालू करें, फिर दोबारा कोशिश करें।',
  'account.scanner.noCamera': 'इस डिवाइस पर कैमरा शुरू नहीं हो पाया।',
  'account.scanner.close': 'बंद करें',
  'account.profile.scanToSignIn': 'स्कैन करके साइन इन',
  // Delete my account (M51, D172).
  'account.delete.row': 'मेरा अकाउंट मिटाएँ',
  'account.delete.rowHint': 'आपका अकाउंट हमेशा के लिए हटा देता है',
  'account.delete.button': 'मिटाएँ',
  'account.delete.title': 'अपना अकाउंट मिटाएँ?',
  'account.delete.intro': 'यह तुरंत होता है और वापस नहीं हो सकता।',
  'account.delete.messages':
    'आपके संदेश परिवारों की चैट में रहेंगे, “मिटाया गया अकाउंट” के नाम से। आपका नाम, फ़ोटो और जन्मदिन हटा दिए जाते हैं।',
  'account.delete.devices':
    'आपकी पासकी, डिवाइस, सेशन और सूचनाएँ हटा दी जाती हैं, और आप हर परिवार और चैट से निकल जाते हैं।',
  'account.delete.roots':
    'जहाँ आप अकेले रूट हैं, वहाँ सबसे पुराना एडमिन (वरना सदस्य) रूट बन जाता है। जिस परिवार में सिर्फ़ आप हैं, वह अपनी हर चीज़ के साथ मिट जाता है।',
  'account.delete.handle':
    'आपका हैंडल @{handle} कभी किसी और को नहीं दिया जाएगा।',
  'account.delete.continue': 'पुष्टि करें कि यह आप हैं',
  'account.delete.confirmTitle': 'अपना अकाउंट हमेशा के लिए मिटाएँ?',
  'account.delete.confirmBody':
    'आख़िरी कदम। मिटाएँ दबाते ही आपका अकाउंट चला जाएगा और यह डिवाइस साइन आउट हो जाएगा।',
  'account.delete.confirm': 'मेरा अकाउंट मिटाएँ',
  'account.delete.keep': 'अकाउंट रखें',
  'account.delete.done': 'आपका अकाउंट मिटा दिया गया',
  // Deleted accounts (M51).
  'account.deletedAccount': 'मिटाया गया अकाउंट',
  'account.family.nowRoot': 'अब आप {name} के रूट हैं',
  'account.family.nowRootBody':
    'इसके अकेले रूट ने अपना अकाउंट मिटा दिया, इसलिए अब परिवार आप सँभालते हैं।',
  // Delete family, and download first (M54, D187–D194).
  'account.dangerZone.title': 'सावधान',
  'account.dangerZone.body':
    'परिवार की फ़ोटो और डॉक्यूमेंट की कॉपी लें, या परिवार को सबके लिए मिटाएँ।',
  'account.dangerZone.bodyAdmin':
    'परिवार की फ़ोटो और डॉक्यूमेंट की कॉपी अपने पास रखें।',
  'account.exportFamily.row': 'फ़ोटो और डॉक्यूमेंट डाउनलोड करें',
  'account.exportFamily.rowHint':
    'आपकी चैट से, डॉक्यूमेंट, लिंक और लिस्ट के साथ, एक ज़िप में',
  'account.exportFamily.button': 'डाउनलोड',
  'account.exportFamily.title': 'फ़ोटो और डॉक्यूमेंट डाउनलोड करें',
  'account.exportFamily.body':
    'एक ज़िप, जिसमें आपकी चैट की फ़ोटो, वीडियो, वॉइस नोट और फ़ाइलें, हर चैट के संदेश टेक्स्ट में, और {family} के डॉक्यूमेंट, लिंक और लिस्ट होंगे।',
  'account.exportFamily.private':
    'यह इसी डिवाइस पर बनती है, जिसके पास चाबियाँ हैं। सर्वर इसमें से कुछ नहीं पढ़ सकता।',
  'account.exportFamily.phoneNote':
    'बहुत सारी फ़ोटो हों तो इसमें समय लग सकता है, ख़ासकर फ़ोन पर। पूरा होने तक Twinden खुला रखें।',
  'account.exportFamily.start': 'डाउनलोड शुरू करें',
  'account.exportFamily.scanning': 'चैट देखी जा रही हैं… {total} में से {done}',
  'account.exportFamily.progress': '{total} में से {done} फ़ाइलें',
  'account.exportFamily.cancel': 'डाउनलोड रोकें',
  'account.exportFamily.doneTitle': 'डाउनलोड हो गया',
  'account.exportFamily.doneBody': '{count} फ़ाइलें “{file}” में सहेजी गईं।',
  'account.exportFamily.skipped':
    '{count} शामिल नहीं हो सकीं। ज़िप में not-included.txt में उनकी सूची है।',
  'account.exportFamily.failed': 'डाउनलोड रुक गया। फिर से कोशिश करें।',
  'account.deleteFamily.row': 'परिवार मिटाएँ',
  'account.deleteFamily.rowHint':
    'परिवार और उसमें सब कुछ, सबके लिए हटा देता है',
  'account.deleteFamily.button': 'मिटाएँ',
  'account.deleteFamily.title': '{family} मिटाएँ?',
  'account.deleteFamily.goes': 'परिवार में सबके लिए, यह हटा देगा:',
  'account.deleteFamily.chats':
    'हर चैट, उसकी सारी फ़ोटो, वीडियो, वॉइस नोट और फ़ाइलों के साथ।',
  'account.deleteFamily.apps': 'डॉक्यूमेंट, लिंक और लिस्ट।',
  'account.deleteFamily.people':
    'सबके स्टार और यहाँ रखे रिश्तों के नाम। सब परिवार से निकल जाएँगे; उनके अकाउंट बने रहेंगे।',
  'account.deleteFamily.invites':
    'परिवार लिंक, और इंतज़ार कर रहे न्योते और जुड़ने के अनुरोध।',
  'account.deleteFamily.intro': 'यह तुरंत होता है और वापस नहीं हो सकता।',
  'account.deleteFamily.downloadFirst': 'पहले डाउनलोड करें',
  'account.deleteFamily.continue': 'पुष्टि करें कि यह आप हैं',
  'account.deleteFamily.keep': 'परिवार रखें',
  'account.deleteFamily.typeTitle': 'परिवार का नाम लिखें',
  'account.deleteFamily.typeBody':
    'इसे सबके लिए मिटाने के लिए, {family} ठीक वैसे ही लिखें जैसा दिख रहा है।',
  'account.deleteFamily.nameLabel': 'परिवार का नाम',
  'account.deleteFamily.confirm': 'परिवार मिटाएँ',
  'account.deleteFamily.done': '{family} मिटा दिया गया',
  'account.deleteFamily.deletedBy': '{family} को {name} ने मिटा दिया।',
  'account.deleteFamily.dismiss': 'ठीक है',
  'account.deleteFamily.gone': 'आप अब {family} में नहीं हैं।',
  'account.exportFamily.size': 'लगभग {size}, {count} फ़ाइलें।',
  'account.exportFamily.parts':
    'यह इस डिवाइस पर एक बार में बनाने के लिए बहुत बड़ा है, इसलिए यह 500 MB तक की {count} ज़िप में आएगा। आप उन्हें एक-एक करके सहेजेंगे।',
  'account.exportFamily.doneParts':
    '{count} फ़ाइलें {parts} ज़िप में सहेजी गईं।',
  'account.exportFamily.partSaved': '{count} में से भाग {part} सहेजा गया',
  'account.exportFamily.nextPart':
    'अगला भाग बनाकर सहेजने के लिए नीचे टैप करें। Twinden खुला रखें।',
  'account.exportFamily.savePart': '{count} में से भाग {part} सहेजें',
  // App review access (M56, D203): the review link's landing.
  'account.review.title': 'Twinden समीक्षा',
  'account.review.signingIn': 'आपको समीक्षा परिवार में साइन इन किया जा रहा है…',
  'account.review.signedInAs':
    'इस डिवाइस पर आप {name} के रूप में साइन इन हैं। समीक्षा परिवार खोलने के लिए साइन आउट करें?',
  'account.review.switch': 'साइन आउट करें और समीक्षा परिवार खोलें',
  'account.review.stay': 'साइन इन रहें',
  'account.review.expired':
    'यह समीक्षा लिंक पुराना हो गया है। Twinden टीम से नया लिंक माँगें।',
  'account.review.revoked':
    'यह समीक्षा लिंक बंद कर दिया गया है। Twinden टीम से नया लिंक माँगें।',
  'account.review.invalid':
    'यह समीक्षा लिंक सही नहीं है। देख लें कि आपने पूरा लिंक कॉपी किया है।',
  'account.review.failed':
    'साइन इन नहीं हो सका। अपना कनेक्शन देखें और फिर कोशिश करें।',
  'account.review.tryAgain': 'फिर कोशिश करें',
  'account.review.home': 'Twinden पर जाएँ',
  'account.sessions.title': 'साइन-इन सेशन',
  'account.sessions.description':
    'हर फ़ोन, कंप्यूटर और ब्राउज़र जो आपके नाम से Twinden खोल सकता है। जिसे न पहचानें, उसे साइन आउट करें।',
  'account.sessions.thisDevice': 'यह डिवाइस',
  'account.sessions.browserOn': '{os} पर {browser}',
  'account.sessions.appFor': '{os} के लिए Twinden',
  'account.sessions.unknown': 'अनजान डिवाइस',
  'account.sessions.via.passkey': 'इसी डिवाइस की पासकी से साइन इन',
  'account.sessions.via.enrolled': 'पासकी बनाते समय साइन इन हुआ',
  'account.sessions.via.passkeyOther': '{name} की पासकी से साइन इन',
  'account.sessions.via.passkeyOtherUnnamed':
    'दूसरे डिवाइस की पासकी से साइन इन',
  'account.sessions.via.qr': '{name} से स्कैन करके साइन इन',
  'account.sessions.via.qrUnnamed': 'आपके फ़ोन से स्कैन करके साइन इन',
  'account.sessions.via.review': 'रिव्यू सेशन',
  'account.sessions.via.unknown': 'पासकी से साइन इन',
  'account.sessions.times': 'पहली बार {first} · आख़िरी बार {used}',
  'account.sessions.firstSeen': 'पहली बार {first}',
  'account.sessions.signOut': 'साइन आउट',
  'account.sessions.signOutNamed': '{name} को साइन आउट करें',
  'account.sessions.signOutTitle': '“{name}” को साइन आउट करें?',
  'account.sessions.signOutBody':
    'एक मिनट के अंदर यह आपके नाम से Twinden खोलना बंद कर देगा, और फिर साइन इन के लिए पासकी चाहिए होगी। इस पर कोई पासकी हो तो वह तब तक रहेगी जब तक आप उसे मेरे डिवाइस में न हटाएँ। पहले पुष्टि करेंगे कि आप ही हैं।',
  'account.sessions.signOutThisTitle': 'इस डिवाइस से साइन आउट करें?',
  'account.sessions.signOutThisBody':
    'यह डिवाइस अभी साइन आउट होगा। जब चाहें अपनी पासकी से फिर साइन इन करें।',
  'account.sessions.keep': 'साइन इन रहने दें',
  'account.sessions.everywhereElse': 'बाक़ी सब जगह से साइन आउट करें',
  'account.sessions.everywhereElseTitle': 'बाक़ी सब जगह से साइन आउट करें?',
  'account.sessions.everywhereElseBody':
    'बाक़ी हर फ़ोन, कंप्यूटर और ब्राउज़र एक मिनट के अंदर साइन आउट हो जाएगा। यह डिवाइस साइन इन रहेगा। आपकी पासकी रहेंगी, तो आपके अपने डिवाइस फिर साइन इन कर सकते हैं। पहले पुष्टि करेंगे कि आप ही हैं।',
  'account.sessions.signedOutOne': 'साइन आउट हो गया',
  'account.sessions.signedOutOther': '{count} सेशन साइन आउट हुए',
  'account.sessions.failed': 'साइन आउट नहीं हो सका',
  'account.sessions.loadFailed': 'आपके सेशन लोड नहीं हो सके',
  'account.sessions.onlyThis': 'कोई और डिवाइस साइन इन नहीं है।',
};
